import { render, staticRenderFns } from "./MatAnswers.vue?vue&type=template&id=38529e14&scoped=true"
import script from "./MatAnswers.vue?vue&type=script&lang=js"
export * from "./MatAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38529e14",
  null
  
)

export default component.exports